/**
 * 依 URL 語言碼決定預設幣種候選；實際是否採用由 `handleDefaultWalletCurrency` 與幣種列表 `isVisible` 決定。
 */

/**
 *
 * @param languageCode
 */
export function getDefaultFiatCurrencyForLanguage(languageCode: string): string {
  const code = (languageCode || '').toLowerCase().trim();
  let candidate: string;

  switch (code) {
    case 'vi':
      candidate = 'VND';
      break;
    case 'th':
      candidate = 'THB';
      break;
    case 'zh-cn':
      candidate = 'CNY';
      break;
    case 'id':
      candidate = 'IDR';
      break;
    case 'en-us':
      candidate = 'USDT';
      break;
    default:
      candidate = 'USDT';
      break;
  }

  return candidate;
}
